export const size = 500
export const mutationRate = 0.01
export const brainSize = 100
export const dotSize = 5
export const populationSize = 10 ** 3.5